import React from 'react';
import cn from 'classnames';
import Offices from './Offices';
import Emails from './Emails';
import Phones from './Phones';
import ContactForm from './ContactForm';
import ContactSupport from '@/Framework/UI/Molecules/ContactSupport';
import Button, { ButtonVariantType } from '@dealroadshow/uikit/core/components/Button';
import IconChat from '@dealroadshow/uikit/core/components/Icon/IconChat';

import contactUsStyles  from './contactUs.scss';

const ContactUs = () => (
  <>
    <div className={ contactUsStyles.contentWrapper }>
      <div className={ contactUsStyles.contentHolder }>
        <div className={ contactUsStyles.contactWrapper }>
          <div className={ contactUsStyles.contactHolder }>
            <Emails />
            <Phones />
            <div className={ contactUsStyles.supportChatWrapper }>
              <ContactSupport>
                <Button
                  variant={ ButtonVariantType.action }
                  dataTest="liveTechSupportButton"
                >
                  <IconChat
                    className={ contactUsStyles.contactSupportIcon }
                  />
                  Live Tech Support
                </Button>
              </ContactSupport>
            </div>
          </div>
          <div className={ cn(contactUsStyles.backgroundNY, contactUsStyles.mobileBG) } />
        </div>
        <ContactForm />
      </div>
      <div className={ cn(contactUsStyles.backgroundNY, contactUsStyles.desktopBG) } />
    </div>
    <Offices />
  </>
);

export default ContactUs;
